import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VLayout,{attrs:{"wrap":""}},[_c('iframe',{attrs:{"width":"100%","height":"1200","src":this.$route.query.link}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }